'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeViolinIcon = function TraceTypeViolinIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { d: 'M7 21.733c0-6.22 4.412-8.674 4.412-13.968 0 5.294 4.411 7.749 4.411 13.968 0 4.756-4.411 7.267-4.411 17.561C11.412 29 7 26.49 7 21.734zm17.039 14.679s.434-5.754 1.856-8.467-.924-6.533.427-9.879a11.606 11.606 0 0 0 0-7.816C25.468 7.862 24.039 3 24.039 3s-1.43 4.862-2.283 7.25a11.606 11.606 0 0 0 0 7.816c1.351 3.346-.995 7.165.427 9.878s1.856 8.468 1.856 8.468zm12.991 3.882a11.821 11.821 0 0 0-2.344-6.03c-1.065-1.507-1.704-6.346-.639-8.549S37.03 12 37.03 12h-.058s1.917 11.512 2.982 13.715.426 7.042-.64 8.55a11.821 11.821 0 0 0-2.342 6.03zM24 36v6M37 3v9', fill: '#25fdfc', stroke: '#1d9bfb', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })
    );
};

exports.default = TraceTypeViolinIcon;